import { render, staticRenderFns } from "./addQuestion.vue?vue&type=template&id=765c6c75&scoped=true&"
import script from "./addQuestion.vue?vue&type=script&lang=js&"
export * from "./addQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765c6c75",
  null
  
)

export default component.exports